<template>
  <base-view
      @click:add="criar"
      :permiteCadastrar="permiteCadastrar"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">

    <CreateEditTipoModificacaoDialog :item="item" v-model="editDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>

    <div>
      <TipoModificacaoDataTable ref="dataTable"
                             @click:edit="editar"
                             @click:remove="remover"
                         :search-values="searchValues"/>
    </div>
  </base-view>

</template>

<script>
import TipoModificacaoDataTable from "../../components/shared/datatables/TipoModificacaoDataTable";
import BaseView from "../BaseView";
import {remove} from "../../api/tipoModificacao";
import CreateEditTipoModificacaoDialog from "../../components/shared/dialogs/CreateEditTipoModificacaoDialog";
import {findAll as findAllGrupo} from '../../api/grupoTipoModificacao';
import {ItemDeDominio} from "../../api/itemsDominio";
import {mapActions, mapGetters} from "vuex";
import {ApiError} from "../../api/core";

export default {
  name: "index",
  components: {CreateEditTipoModificacaoDialog, BaseView, TipoModificacaoDataTable},
  data() {
    return {
      item: null,
      editDialogOpened: false,
      permiteCadastrar: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'ID',
          column: 'id',
          type: 'number',
          prefix: '#'
        },
        {
          name: 'Agrupamento',
          column: 'idGrupo',
          type: 'autocomplete',
          optionsFactory: (search) => findAllGrupo(1,{
            nome: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        },          
        {
          name: 'Descricao',
          column: 'descricao',
          type: 'text'
        },
        {
          name: 'Modifica Valor',
          column: 'flgValor',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.FLG_PADRAO
          })
        },  
        {
          name: 'Modifica Data',
          column: 'flgData',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.FLG_PADRAO
          })
        },                  
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
  },  
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    updateSearch(search) {
      this.searchValues = search;
    },
    criar() {
      this.item = {};
      this.editDialogOpened = true;
    },
    editar(objeto) {
      this.item = JSON.parse(JSON.stringify(objeto));
      this.editDialogOpened = true;
    },
    async remover({id}) {
      try {
        await remove(id);
        this.$toast.success(`Tipo de Modificação removido com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {           
          this.$toast.error(`Não foi possível remover o Tipo de Modificação.`, {
            timeout: 6000
          })
        }
      }
    },
	  async getPermissoes(){
      this.permiteCadastrar = await this.getPermissaoPorItemPerfil("TipoModificacao.cadastro",this.nivelUsuarioLogado);
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>